"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundingRequestComponentTypes = exports.FundingRequestComponentTypeSchema = void 0;
const zod_1 = require("zod");
exports.FundingRequestComponentTypeSchema = zod_1.z.enum([
    'collectionsPaydown',
    'collectionsRecycle',
    'curePaydown',
    'drawRequest',
]);
// String constants for FundingRequestComponentType (replacement for the deprecated enum)
exports.FundingRequestComponentTypes = {
    CollectionsPaydown: 'collectionsPaydown',
    CollectionsRecycle: 'collectionsRecycle',
    CurePaydown: 'curePaydown',
    DrawRequest: 'drawRequest',
};
//# sourceMappingURL=SharedFundingRequest.js.map